module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/showcase-59.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/about/showcase.md
// module id = 631
// module chunks = 402